module.exports = __webpack_public_path__ + "img/08.dfee5b0c.png";